import { render } from "./TaskDates.vue?vue&type=template&id=26952a9a"
import script from "./TaskDates.vue?vue&type=script&lang=js"
export * from "./TaskDates.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__